import { ResponseErrorDto } from '@interfaces/models';
import { useMutation } from '@tanstack/react-query';
import { bulkDeleteVehicles } from '@api/vehicles';
import { useTranslation } from 'react-i18next';
import { toast } from '@ui/components';
import { useCallback } from 'react';

export const useBulkRemoveVehicleDialog = (onSuccess: () => void) => {
  const { t } = useTranslation();

  const { mutate: bulkDeleteVehiclesMutation, isPending: isBulkDeleteVehiclesLoading } =
    useMutation({
      mutationFn: bulkDeleteVehicles,
      onSuccess: () => {
        onSuccess?.();
        toast.success(t('VEHICLES.BULK_DELETE_SUCCESS'));
      },
      onError: ({ error }: { error: ResponseErrorDto }) => {
        toast.error(`API_ERRORS.${error.errorCode || 'DEFAULT'}`);
      },
    });

  const handleBulkDeleteVehicles = useCallback(
    (ids: string[]) => {
      bulkDeleteVehiclesMutation({ ids });
    },
    [bulkDeleteVehiclesMutation],
  );

  return {
    removeVehicle: handleBulkDeleteVehicles,
    isPending: isBulkDeleteVehiclesLoading,
    t,
  };
};
